import {View, Text, Image, Linking, TouchableOpacity} from 'react-native';
import React from 'react';
import {styles} from './styles';
import {Images} from '../../../../constants/Images';
import ChecBoxVessel from './CheckBoxVessel/ChecBoxVessel';

interface IVesselAlert {
  containers: {description: string; total: number; vessel: string}[];
  returnCheck: (check: boolean) => void;
  redirectContainers: () => void;
}

const VesselAlert = ({containers, returnCheck, redirectContainers}: IVesselAlert) => {
  return (
    <View style={styles.container}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '100%',
        }}>
        <Image
          source={Images.warningB}
          style={{
            width: 15,
            height: 15,
            marginRight: 10,
          }}
        />
        <Text
          style={{
            fontSize: 12,
            lineHeight: 16,
            fontFamily: 'TCCC-UnityText Bold',
            color: 'black',
            maxWidth: 250,
          }}>
          Atenção! Produto com vasilhame adicionados:
        </Text>
      </View>
      <View>
        <Text
          style={{
            fontSize: 12,
            lineHeight: 16,
            fontFamily: 'TCCC-UnityHeadline Regular',
            color: 'black',
            marginTop: 10,
          }}>
          Confira a quantidade de vasilhame adicionada para os produtos abaixo:
        </Text>
        <View
          style={{
            marginTop: 10,
            display: 'flex',
            flexDirection: 'column',
          }}>
          {containers.map(container => (
            <Text
              key={container.description}
              style={{
                fontSize: 12,
                lineHeight: 16,
                fontFamily: 'TCCC-UnityHeadline Regular',
                color: 'black',
                marginBottom: 5,
              }}>
              {container.description}: {container.total} {container.vessel}
            </Text>
          ))}
        </View>
      </View>
      <ChecBoxVessel returnCheck={returnCheck} />
      
    </View>
  );
};

export default VesselAlert;
